<template>
  <div class="c-teachers">
    <p class="c-teachers-title">
      讲师介绍
    </p>
    <ul class="c-teachers-list">
      <li class="c-teachers-item" v-for="(teacher,teacherIndex) in teachersInfo" :key="teacherIndex">
        <div class="c-teachers-item-img">
          <img :src="teacher.thumb" alt="">
        </div>
        <p class="e-teachers-item-name">{{teacher.title}}</p>
        <p v-if="teacher.reason" class="e-teachers-item-title">{{teacher.reason}}</p>
        <div class="c-teacher-item-desc">
          <p>
            {{teacher.content}}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: ['teachersInfo'],
  data() {
    return {
      
    }
  },
  computed: {
    
  },
  mounted() {

  }
}
</script>

<style lang="scss">
.c-teachers{
  padding-bottom: 100px;
  padding-top: 140px;
  .c-teachers-title{
    text-align: center;
    line-height: 48px;
    font-size: 36px;
    margin-bottom: 60px;
  }
  .c-teachers-list{
    width: 900px;
    margin: 0 auto;
    overflow-x: auto;
    font-size: 0;
    white-space: nowrap;
    padding-bottom: 60px;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      height: 10px;
      overflow: visible;
      border-radius: 10px;
      overflow: hidden;
      cursor: pointer;
    }
    &::-webkit-scrollbar-track {
      /* 滚动条轨道 */
      // background-color: transparent;
      background-image: linear-gradient(to bottom, transparent, transparent 40%, #F6F6F6 40%, #F6F6F6 60%, transparent 60%, transparent 100%);
      height: 10px;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      /* 滚动条手柄 */
      border-radius: 10px;
      background-color: #E2E2E2;
      width: 10px;
      height: 10px;
      &:hover{
        background-color: #CFD0D1;
      }
    }
    .c-teachers-item{
      display: inline-block;
      width: 280px;
      height: 350px;
      box-sizing: border-box;
      border: 1px solid #EFEFEF;
      text-align: center;
      margin-right: 30px;
      position: relative;
      &:nth-last-child(1){
        margin-right: 0;
      }
      .c-teachers-item-img{
        width: 280px;
        height: 260px;
        margin-left: -1px;
        margin-top: -1px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .e-teachers-item-name{
        margin-top: 18px;
        margin-bottom: 7px;
        line-height: 24px;
        font-size: 18px;
      }
      .e-teachers-item-title{
        line-height: 17px;
        font-size: 13px;
        color: #7A7D80;
      }
      .c-teacher-item-desc{
        opacity: 0;
        position: absolute;
        z-index: -1;
        width: 280px;
        height: 350px;
        background-color: #6C7178;
        top: -1px;
        left: -1px;
        transition: all .3s;
        padding: 25px;
        box-sizing: border-box;
        color: #E3E4E6;
        line-height: 23px;
        font-size: 12px;
        white-space: normal;
        text-align: left;
        overflow: hidden;
        p{
          overflow: hidden;
          max-height: 300px
        }
      }
      &:hover .c-teacher-item-desc{
        opacity: 1;
        z-index: 1;
      }
    }
  }
}
</style>
